import React, { PropsWithChildren } from 'react';

import { cn } from '../../../helpers/classBuilders';
import { useClassHelper } from '../../../hooks';

export interface LabelProps
  extends PropsWithChildren,
    React.LabelHTMLAttributes<HTMLLabelElement> {
  id: string;
  required?: boolean;
  className?: string;
  baseClass?: string;
}

export const Label: React.FC<LabelProps> = ({
  children,
  id,
  required = false,
  className,
  baseClass = '',
}) => {
  const c = useClassHelper(baseClass);
  return (
    <label
      className={cn(
        c('__label', { '__label--required': required }),
        className,
      )}
      htmlFor={id}
    >
      {children}
    </label>
  );
};
